const CARD_TYPES = [
    {
        type: 'visa',
        name: 'VISA',
        pattern: /^4/,
        format: /(\d{4})/g,
        length: [16],
        cvvLength: [3],
    },
    {
        type: 'mir',
        name: 'MIR',
        pattern: /^220[0-4]/,
        format: /(\d{1,4})/g,
        length: [16, 17, 18, 19],
        cvvLength: [3],
    },
    {
        type: 'mastercard',
        name: 'MasterCard',
        pattern: /^(5[1-5])|^(2[3-7])|^(222)/,
        format: /(\d{4})/g,
        length: [16],
        cvvLength: [3],
    },
    {
        type: 'maestro',
        name: 'Maestro',
        pattern: /^(5[0|6-9]|6)/,
        format: /(\d{8}){1}(\d{9,11}){1}/,
        length: [16, 17, 18, 19],
        cvcLength: [3],
    },
];

const creditCardTypes = {
    types: CARD_TYPES,
    defaultTypes: ['visa', 'mir', 'mastercard', 'maestro'],

    getCardInfoByNumber(num) {
        let card;
        let i;
        const len = CARD_TYPES.length;

        if (num) {
            for (i = 0; i < len; i++) {
                card = CARD_TYPES[i];
                if (card.pattern.test(num)) {
                    return card;
                }
            }
        }

        return null;
    },

    getCardInfoByType(type) {
        let card;
        let i;
        const len = CARD_TYPES.length;

        for (i = 0; i < len; i++) {
            card = CARD_TYPES[i];
            if (card.type === type) {
                return card;
            }
        }
        return null;
    },
};

export default creditCardTypes;
export { creditCardTypes };
